import { defineWave } from '../schema';

/** BLOC D1 — LE TISSAGE. Première brique du monde 2, et sa leçon d'ouverture.
 *
 *  ── Le Tisseur est introduit SEUL ──
 *  Les douze premières secondes ne contiennent qu'un Tisseur, sans le moindre
 *  popcorn. C'est la règle appliquée à l'Éclat au monde 1, et elle vaut pour
 *  toute nature de menace inédite : un mur avec un trou qui glisse est une
 *  figure qu'il faut LIRE avant de pouvoir la traverser, et on ne lit rien en
 *  esquivant simultanément autre chose.
 *
 *  ── Puis le mur devient un rythme ──
 *  À 12 s, un second Tisseur entre par l'autre moitié du terrain. Leurs trous
 *  glissent dans le même sens, ce qui produit une ouverture unique qui balaye
 *  le terrain — le joueur cesse d'esquiver et se met à SUIVRE un couloir. C'est
 *  la sensation que le monde entier cherche à installer.
 *
 *  ── Le popcorn arrive après, jamais avant ──
 *  Les Mites ne tombent qu'une fois la figure comprise, et dans le couloir que
 *  le trou vient de quitter : elles récompensent le joueur d'avoir bougé au bon
 *  moment au lieu de le punir d'avoir tardé. */
export default defineWave({
  id: 'd1-tissage',
  duration: 26,
  spawns: [
    { at: 0.5, enemy: 'tisseur', lane: 2, count: 1, spacing: 0 },
    { at: 12.0, enemy: 'tisseur', lane: 4, count: 1, spacing: 0 },
    { at: 14.5, enemy: 'mite', lane: 1, count: 5, spacing: 0.09 },
    { at: 17.0, enemy: 'eclat', lane: 3, count: 2, spacing: 0.6 },
    { at: 19.5, enemy: 'mite', lane: 5, count: 6, spacing: 0.08 },
    { at: 22.0, enemy: 'tisseur', lane: 3, count: 1, spacing: 0 },
  ],
});
